import { css } from "../../../../../styled-system/css";

export const styles = {
  wrapper: () =>
    css({
      width: "100%",
      maxWidth: "560px",
      marginBottom: "baseUnit.mobile2",
      "& video": {
        width: "100%",
        height: "auto",
        aspectRatio: "16 / 9",
        objectFit: "contain",
      },
      tablet: {
        marginBottom: 0,
        "& video": {
          width: "560px",
          height: "315px",
          aspectRatio: "auto",
        },
      },
    }),
};
